import { HeaderLink } from '@lib/types/cms/Header';
import { HeaderMenuListItem } from '../Header/Navigation/common/HeaderMenuListItem';
import { Overlay } from '../Overlay';

type FastActionMenuDropdownProps = {
  title: string;
  dropdownMenu: HeaderLink[];
  onBlur?: () => void;
};

export const FastActionMenuDropdown = ({
  title,
  dropdownMenu,
  onBlur = () => {},
}: FastActionMenuDropdownProps) => {
  const onListItemBlur = (e: React.FocusEvent) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      onBlur();
    }
  };
  return (
    <>
      <Overlay />
      <div
        role="menu"
        tabIndex={-1}
        onBlur={onListItemBlur}
        className="z-modal absolute right-0 top-12 w-72 rounded-md bg-black px-4 py-6 md:-right-8"
        aria-label={title}
      >
        <h2 className="caption pb-6 text-left text-grey-500">{title}</h2>
        <ul>
          {dropdownMenu.map((item) => (
            <li key={item?.url} className="pb-4 last:pb-0">
              <HeaderMenuListItem
                href={item?.url || ''}
                openInNewTab={Boolean(item?.openInNewTab)}
                iconName={item?.icon || ''}
                value={item?.value || ''}
              />
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
